import * as postFiniteActions from '../../action_creators/post/post_finite_action_creators';
import PostFiniteModel from '../../../models/post/post_finite_module';
import log from '../../../services/logger_service';

export default function fetchPostDetail(dispatch, id, advertorialTag, config) {
  dispatch(postFiniteActions.postFiniteLoading());
  return PostFiniteModel.fetch(id, advertorialTag, config)
    .then(function handlePostDetailData(resp) {
      dispatch(postFiniteActions.postFiniteLoaded(resp.data));
    })
    .catch(function handleUserError(err) {
      dispatch(postFiniteActions.postFiniteLoadError(err));
      log.error(err, `Error in post finite actions, message: ${err.message}`);
    });
}
